import { getAppPushActivatedInfo, saveAppPushInfo, setPushActivate } from "api/common/Auth.api";
import { PAGE_TYPE } from "enums";
import { getLanguageValue } from "locales/i18n";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PushCheckComponent from "./PushCheck.component";
import { checkHasPushPermission, openAppSetting } from "helpers/InApp.helper";

const PushCheckContainer = (props: any) => {
    const { isApp } = useSelector((state: any) => state.common);
    const [isActivated, setIsActivated] = useState(false);

    const getPushActivatedInfo = async () => {
        // device의 push 세팅값 가져오기
        const devicePushPermission = await checkHasPushPermission();

        // device의 push 세팅값이 true 인 경우 서버의 세팅값 가져오기
        if (devicePushPermission) {
            const result = await getAppPushActivatedInfo();

            if (result) {
                setIsActivated(result.info?.isActivated);
            }
        }
        // device의 push 세팅값이 false 인 경우 서버에 세팅값 저장
        else {
            await saveAppPushInfo();
            await setPushActivate({ isActivated: devicePushPermission });
            setIsActivated(devicePushPermission);
        }
    };

    // 푸시 알람 허용 여부 서버에 저장
    const saveIsActivateValue = async (isActivated: boolean) => {
        const result: any = await setPushActivate({ isActivated });
        alert(isActivated ? 'a' : 'b')
        alert(result.status)

        if (result && result.status === 200) {
            getPushActivatedInfo();
        } else {
            alert(result?.data?.message);
        }
    };

    const changeActivated = async (e: ChangeEvent): Promise<void> => {
        const target = e.target as HTMLInputElement;
        const isChecked: boolean = target.checked;

        // device의 push 세팅값 가져오기
        const devicePushPermission: boolean = await checkHasPushPermission();

        // device의 push 세팅값이 false인데 push를 허용하는 경우 device 설정 화면 오픈
        if (isChecked && !devicePushPermission) {
            const confirmUpdate: boolean = window.confirm(getLanguageValue(PAGE_TYPE.COMMON, "app.txtDeviceAppSettingConfirm"));

            if (confirmUpdate) {
                await openAppSetting();

                (window as any).flutter_inappwebview.onResumeApp = async (event: any): Promise<void> => {
                    const deviceIsCheckedValue: boolean = await checkHasPushPermission();
                    await saveIsActivateValue(deviceIsCheckedValue);
                };
            } else {
                setIsActivated(!isChecked);
            }
        }
        // device의 push 세팅값이 true 인 경우는 바로 서버에 값 저장
        else {
            await saveIsActivateValue(isChecked);
        }
    };

    useEffect(() => {
        if (isApp) {
            getPushActivatedInfo();
        }
    }, []);

    return (
        <PushCheckComponent
            isActivated={isActivated}
            changeActivated={changeActivated}
        />
    )
};

export default PushCheckContainer;
